import * as moment from 'moment';
import 'moment/locale/de';
import * as React from 'react';
import { InputGroup, Table } from 'reactstrap';
import { TR } from 'src/TextRes';
import { Booking } from '../../api';
import FAIcon from '../fAIcon/FAIcon';
import { IThConfig } from '../sortableTh/SortableTh';
import { TableBox } from '../tableBox/TableBox';

interface TableBoxForCPBookingsProofedState {
    showMore: boolean[];
}

export interface TableBoxForCPBookingsProofedProps {
    listData: Booking[];
    renderTHeadLine: IThConfig[];
}

export default class TableBoxForCPBookingsProofed extends React.PureComponent<
    TableBoxForCPBookingsProofedProps,
    TableBoxForCPBookingsProofedState
> {
    constructor(props: TableBoxForCPBookingsProofedProps) {
        super(props);
        this.state = {
            showMore: [],
        };
    }

    public componentDidMount() {
        const showMoreArray: boolean[] = [];
        this.props.listData.map((b: Booking) => {
            showMoreArray.push(false);
        });
        this.setState({
            showMore: [...showMoreArray],
        });
    }

    public render() {
        const noResultsMessage = TR.tableBoxForCPBookingsProofed_no_results;

        if (!this.props.listData || this.props.listData.length < 1) {
            return (
                <legend className="my-3" style={{ color: 'red' }}>
                    {noResultsMessage}
                </legend>
            );
        }

        const renderTHeadLine = (
            <tr>
                {this.props.renderTHeadLine.map((str: IThConfig, index: number) => {
                    return (
                        <th key={str.name + index} style={{ width: str.width }}>
                            {str.name}
                        </th>
                    );
                })}
            </tr>
        );

        return (
            <TableBox
                listData={this.props.listData}
                renderTBodyLine={this.renderTBodyLine}
                renderTHeadLine={renderTHeadLine}
            />
        );
    }

    private renderTBodyLine = (value: Booking, index: number) => {
        return (
            <React.Fragment key={value.FirstName + value.LastName + (index + 1)}>
                <tr>
                    <td>
                        <InputGroup>
                            <a
                                onClick={() => {
                                    const showMoreN: boolean[] = this.state.showMore;
                                    showMoreN[index] = !showMoreN[index];
                                    this.setState({
                                        showMore: [...showMoreN],
                                    });
                                }}
                                className=" pull-right"
                            >
                                {this.state.showMore[index] ? (
                                    <FAIcon mouseHover="Weniger anzeigen" icon="minus-circle" />
                                ) : (
                                    <FAIcon mouseHover="Mehr anzeigen" icon="plus-circle" />
                                )}
                            </a>{' '}
                            &nbsp;{value.FirstName + ' ' + value.LastName}
                        </InputGroup>
                    </td>
                    <td>{moment(value.InsertDate).format('DD.MM.YYYY').toString()}</td>
                    <td>{value.BookingOptionName}</td>
                    <td className="text-right">
                        {((value.Rejected && this.props.listData[index].Reason === 'Teilstorno') || !value.Rejected) &&
                            value.BookingOptionPrice !== undefined &&
                            this.formatNumber(value.BookingOptionPrice)}
                        {((value.Rejected && this.props.listData[index].Reason === 'Teilstorno') ||
                            !value.Rejected) && <>&nbsp;€</>}
                        {this.props.listData[index].Reason !== 'Teilstorno' && value.Rejected && '-'}
                    </td>
                    <td className="text-right">
                        {((value.Rejected && this.props.listData[index].Reason === 'Teilstorno') || !value.Rejected) &&
                            value.BookingOptionName &&
                            value.BookingOptionPrice !== undefined &&
                            this.formatNumber(value.CommissionFee)}
                        {((value.Rejected && this.props.listData[index].Reason === 'Teilstorno') ||
                            !value.Rejected) && <>&nbsp;€</>}
                        {this.props.listData[index].Reason !== 'Teilstorno' && value.Rejected && '-'}
                    </td>
                </tr>

                {this.state.showMore[index] && (
                    <tr>
                        <td colSpan={6}>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>{TR.tableBoxForCPBookingsProofed_name}</th>
                                        <th>{TR.tableBoxForCPBookingsProofed_address}</th>
                                        <th>{TR.tableBoxForCPBookingsProofed_telephone}</th>
                                        <th>{TR.tableBoxForCPBookingsProofed_email}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{value.FirstName + ' ' + value.LastName}</td>
                                        <td>
                                            {value.Street && value.Street !== '' ? (
                                                <>
                                                    {value.Street}, &nbsp;
                                                    {value.Zip}
                                                    &nbsp;
                                                    {value.City}
                                                </>
                                            ) : (
                                                '-'
                                            )}
                                        </td>
                                        <td>{value.Telephone && value.Telephone !== '' ? value.Telephone : '-'}</td>
                                        <td>{value.Email && value.Email !== '' ? value.Email : '-'}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4} className="text-center">
                                            {value.Note && value.Note !== '' ? value.Note : '-'}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </td>
                    </tr>
                )}
                <>
                    {value.Rejected && (
                        <tr>
                            <td colSpan={6}>
                                <div style={{ border: '1px solid red', padding: '15px' }}>
                                    {TR.tableBoxForCPBookingsProofed_not_confirmed} &nbsp;
                                    {value.Reason}
                                </div>
                            </td>
                        </tr>
                    )}
                </>
            </React.Fragment>
        );
    };

    private formatNumber = (n: number) => {
        return n.toLocaleString('de-DE', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
            useGrouping: false,
        });
    };
}



// WEBPACK FOOTER //
// ./src/components/cpBookingRequests/TableBoxForCPBookingsProofed.tsx